export default __webpack_public_path__ + "static/committer-480e4e269cdc11b422bb747bcd545daa.svg";